export interface IKeyValuePair {
	Id?: number,
	IdType?: number,
	IdParent?: number,
	Name?: string,
	Value?: any,
	Title?: any,
	Filters?: any
	FilterCall?: number,
	Description?: string,
	Priority?: number
}

export class KeyValuePair implements IKeyValuePair {
	public Id?: number;

	public IdType?: number;

	public Name?: string;

	public Value?: any;

	public Title?: any;

	public Filters?: any;

	public FilterCall?: number;

	public Description?: string;

	public Priority?: number;

	constructor(data: Partial<KeyValuePair> = {}) {
		data = data || {};

		Object.assign(this, data);
	}
}

export interface IKeyFilter {
	Id?: number,
	IdType?: number,
	Name?: string,
	Value?: string,
	SecondValue?: string,
	MinQuantity?: number,
	Priority?: number,
	Resource?: string,
	DateClose?: string,
	IdParent?: number,
	CanCreateLogin?: boolean,
	IsMainSection?: boolean,
	Visible?: boolean,
	CanAssign?: boolean,
	Options?: IKeyValuePair,
	SelectedOptions?: Array<IKeyValuePair>,
}

export class KeyFilter implements IKeyFilter {
	Id?: number;
	IdType?: number;
	Name?: string;
	Value?: string;
	SecondValue?: string;
	MinQuantity?: number;
	Priority?: number;
	Resource?: string;
	DateClose?: string;
	IdParent?: number;
	CanCreateLogin?: boolean;
	IsMainSection?: boolean;
	Visible?: boolean;
	CanAssign?: boolean;
	Options?: IKeyValuePair;
	SelectedOptions?: Array<IKeyValuePair>;

	constructor(data: Partial<IKeyFilter> = {}) {
		data = data || {};

		this.Id = data.Id || 0;
		this.IdType = data.IdType || 0;
		this.Name = data.Name || null;
		this.Value = data.Value || null;
		this.SecondValue = data.SecondValue || null;
		this.MinQuantity = data.MinQuantity || 0;
		this.Priority = data.Priority || 0;
		this.Resource = data.Resource || null;
		this.DateClose = data.DateClose || null;
		this.IdParent = data.IdParent || 0;
		this.CanCreateLogin = data.CanCreateLogin || false;
		this.IsMainSection = data.IsMainSection || false;
		this.Visible = data.Visible || false;
		this.CanAssign = data.CanAssign || false;
		this.Options = data.Options || null;
		this.SelectedOptions = data.SelectedOptions || null;
	}
}